module.exports = __webpack_public_path__ + "8fd9b2de82a6b5cc25cd85206d8946a2.png";